<template>
  <div class="home-page">
    <div class="home-card">
      <div class="home-icon">💰</div>
      <h1>記帳本</h1>
      <p class="home-sub">輕鬆管理你的財務，掌握每一筆開銷</p>
      <div class="home-features">
        <div class="feature">
          <span class="feature-icon">✏️</span>
          <strong>輕鬆記帳</strong>
          <small>快速記錄支出、收入和轉帳</small>
        </div>
        <div class="feature">
          <span class="feature-icon">📊</span>
          <strong>統計分析</strong>
          <small>查看支出統計和月度報表</small>
        </div>
        <div class="feature">
          <span class="feature-icon">🔒</span>
          <strong>安全可靠</strong>
          <small>資料加密，隱私有保障</small>
        </div>
      </div>
      <router-link to="/login" class="home-cta">🔐 立即登入</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeView'
}
</script>

<style scoped>
.home-page {
  display: flex;
  justify-content: center;
  padding-top: 40px;
}
.home-card {
  background: var(--card);
  border-radius: var(--radius);
  box-shadow: var(--shadow-md);
  padding: 48px 40px;
  text-align: center;
  max-width: 560px;
  width: 100%;
}
.home-icon { font-size: 56px; margin-bottom: 12px; }
.home-card h1 {
  font-size: 32px;
  font-weight: 700;
  color: var(--text);
  margin-bottom: 8px;
}
.home-sub {
  font-size: 16px;
  color: var(--text-light);
  margin-bottom: 32px;
}
.home-features {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-bottom: 32px;
}
.feature {
  background: #f9fafb;
  border-radius: 10px;
  padding: 20px 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}
.feature-icon { font-size: 28px; }
.feature strong { font-size: 14px; color: var(--text); }
.feature small { font-size: 12px; color: var(--text-light); }
.home-cta {
  display: inline-block;
  padding: 12px 32px;
  background: var(--primary);
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border-radius: 10px;
  text-decoration: none;
  transition: all 0.2s;
}
.home-cta:hover {
  background: var(--primary-hover);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(79,70,229,0.3);
}

@media (max-width: 480px) {
  .home-features { grid-template-columns: 1fr; }
  .home-card { padding: 32px 20px; }
}
</style>
